import { CATEGORIES_FETCH, CATEGORIES_FETCH_SUCCESS } from "./types";

export const categoriesFetch = () => {
  return {
    type: CATEGORIES_FETCH,
  };
};

export const categoriesFetchSuccess = (payload) => {
  return {
    type: CATEGORIES_FETCH_SUCCESS,
    payload: payload,
  };
};
